// English translations for the orders page (French string -> English).
const m: Record<string, string> = {
  // Page header + actions
  'Commandes': 'Orders',
  '{n} commande(s) au total': '{n} order(s) total',
  '+ Lien d\'upload client': '+ Customer upload link',
  '+ Nouvelle commande': '+ New order',

  // Filters / search
  'Tous les statuts': 'All statuses',
  'Rechercher par nom, téléphone, commande...': 'Search by name, phone, order...',

  // Quick-select + bulk action bar
  'Sélectionner « En production »': 'Select "In production"',
  '{n} commande(s) sélectionnée(s)': '{n} order(s) selected',
  'Effacer la sélection': 'Clear selection',
  'Envoyer à l\'imprimeur': 'Send to printer',
  'Supprimer {n} commandes': 'Delete {n} orders',
  'Supprimer la commande': 'Delete order',

  // Table
  'Aucune commande trouvée': 'No orders found',
  'Sélectionner toutes les commandes visibles': 'Select all visible orders',
  'Commande': 'Order',
  'Formule': 'Bundle',
  'Destination': 'Destination',

  // Pagination
  'Page {page} · {pages} pages': 'Page {page} · {pages} pages',
  'Précédent': 'Previous',
  'Suivant': 'Next',

  // Manual order modal — errors
  'Nom et téléphone sont obligatoires': 'Name and phone are required',
  'Commande créée mais génération du lien échouée : {error}. Ouvrez la commande pour réessayer.':
    'Order created but link generation failed: {error}. Open the order to retry.',
  'erreur inconnue': 'unknown error',
  'Erreur lors de la création': 'Error during creation',

  // Upload-link WhatsApp message
  'Bonjour {name} 👋\n\nVoici votre lien sécurisé pour envoyer vos photos à Storiz :\n{url}\n\nCliquez, glissez vos photos et c\'est tout. On s\'occupe du reste 📸✨':
    'Hello {name} 👋\n\nHere is your secure link to send your photos to Storiz:\n{url}\n\nClick, drag your photos, and that\'s it. We take care of the rest 📸✨',

  // Upload-link success view
  'Lien d\'upload prêt': 'Upload link ready',
  'Envoyez ce lien à {name}': 'Send this link to {name}',
  'Le client pourra téléverser ses photos sans se connecter. Lien valide jusqu\'au {date}.':
    'The customer can upload their photos without signing in. Link valid until {date}.',
  '✓ Copié': '✓ Copied',
  'Envoyer sur WhatsApp': 'Send on WhatsApp',

  // Manual order form
  'Nouveau lien d\'upload client': 'New customer upload link',
  'Nouvelle commande manuelle': 'New manual order',
  'Remplissez les infos client. Après création, vous obtiendrez un lien à envoyer au client pour qu\'il téléverse ses photos.':
    'Fill in the customer details. After creating, you will get a link to send the customer so they can upload their photos.',
  'Nom complet *': 'Full name *',
  'Ex: Sara Bennani': 'e.g. Sara Bennani',
  'WhatsApp *': 'WhatsApp *',
  'Ex: 0612345678': 'e.g. 0612345678',
  'Email': 'Email',
  'optionnel': 'optional',
  'Formule *': 'Bundle *',
  'Solo (1 album)': 'Solo (1 album)',
  'Duo (2 albums)': 'Duo (2 albums)',
  'Trio (3 albums)': 'Trio (3 albums)',
  'Nombre de pages *': 'Number of pages *',
  'Prix total (MAD)': 'Total price (MAD)',
  'Mise en page': 'Layout',
  'Ex: 1 image par page': 'e.g. 1 image per page',
  'Destinations ({n} album(s))': 'Destinations ({n} album(s))',
  'Destination {n}': 'Destination {n}',
  'Ex: Bali': 'e.g. Bali',
  'Année {n}': 'Year {n}',
  'Ex: 2026': 'e.g. 2026',
  'Note': 'Note',
  'Note interne': 'Internal note',
  'Ex: paiement en espèces, livraison spéciale...': 'e.g. cash payment, special delivery...',
  'Créer + générer le lien': 'Create + generate link',
  'Créer la commande': 'Create order',

  // Order row
  'Ouvrir la commande {name}': 'Open order {name}',
  'Sélectionner {name}': 'Select {name}',
  'Source : {source}': 'Source: {source}',
  'Changer le statut': 'Change status',
  'actuel': 'current',
  'Changer le statut de': 'Change the status of',
  'en': 'to',
  'Mise à jour…': 'Updating…',
  'La mise à jour du statut a échoué. Réessayez.': 'Status update failed. Please try again.',
  'Voir →': 'View →',

  // Bulk delete modal
  'Supprimer les commandes sélectionnées': 'Delete selected orders',
  'Action irréversible.': 'Irreversible action.',
  'Toutes les photos, PDF et colis AMEEX associés seront supprimés.':
    'All associated photos, PDFs and AMEEX parcels will be deleted.',
  'Les brouillons Shopify seront supprimés et les commandes Shopify réelles seront annulées.':
    'Shopify drafts will be deleted and real Shopify orders will be cancelled.',
  'Synchroniser avec Shopify (recommandé)': 'Sync with Shopify (recommended)',
  'Tapez': 'Type',
  'pour confirmer': 'to confirm',
  'Suppression en cours…': 'Deleting…',
  'Erreur réseau': 'Network error',
  'Supprimer {n} commande(s)': 'Delete {n} order(s)',
  '{ok} sur {total} supprimée(s).': '{ok} of {total} deleted.',
  'Voir les détails ci-dessous.': 'See details below.',
  '✓ Supprimée': '✓ Deleted',
  'Échec': 'Failed',

  // Send-to-printer modal
  'Aucune commande prête : régénérez les PDF puis réessayez.':
    'No order ready: regenerate the PDFs then try again.',
  'Échec de la création du lien.': 'Failed to create the link.',
  'Lien imprimeur (commande groupée)': 'Printer link (grouped order)',
  '{orders} commande(s) · ~{files} fichier(s) PDF.': '{orders} order(s) · ~{files} PDF file(s).',
  'Un ZIP par commande est préparé dans votre navigateur, puis réuni dans UN lien (valable 7 jours, sans connexion). Les commandes dont le PDF n\'est pas prêt sont ignorées — régénérez-les d\'abord.':
    'One ZIP per order is prepared in your browser, then bundled into ONE link (valid 7 days, no login). Orders whose PDF is not ready are skipped — regenerate them first.',
  '({n} album(s))': '({n} album(s))',
  'PDF prêt': 'PDF ready',
  'à régénérer': 'to regenerate',
  'Générer le lien': 'Generate link',
  'Lien prêt : {n} commande(s) incluse(s).': 'Link ready: {n} order(s) included.',
  'Ignorée(s) : {list}': 'Skipped: {list}',
  'Lien à envoyer à l\'imprimeur (WhatsApp / email) — valable 7 jours, sans connexion :':
    'Link to send the printer (WhatsApp / email) — valid 7 days, no login:',
  'Ouvrir la page de téléchargement →': 'Open the download page →',
  'Création du lien…': 'Creating link…',
  'Impossible d\'envoyer : originaux manquants ({list}). Le client doit re-téléverser ces photos avant l\'impression.':
    'Can’t send: missing print originals ({list}). The customer must re-upload these photos before printing.',
  '{n} photo(s) manquante(s)': '{n} photo(s) missing',
  // The payment chip — lib/paidState.ts (2026-10-06).
  'Rien à payer : payé en entier, ou livré': 'Nothing left to pay: paid in full, or delivered',
  'Avance reçue — le reste à la livraison': 'Advance received — the rest on delivery',
  'Reçu envoyé — à vérifier par une personne': 'Receipt sent — a person must check it',
  'Reçu à vérifier': 'Receipt to check',
  // Archived orders (2026-10-10, migration 226).
  'Archivées (ni photos ni argent)': 'Archived (no photos, no money)',
  'Archivée': 'Archived',
};
export default m;
